import { styled } from "@mui/material/styles";
import {
    FormControl, Grid, InputLabel, Switch,
} from "@mui/material";
import React from "react";

// const PREFIX = "CustomSwitch";
//
// const classes = {
//     base: `${PREFIX}-base`,
//     noLabel: `${PREFIX}-noLabel`,
// };

const StyledFormControl = styled(FormControl, {
    shouldForwardProp: (prop) => !["falseColor", "trueColor", "label"].includes(prop),
})(({
    theme, falseColor, trueColor, label,
}) => ({
    "& .MuiSwitch-thumb": {
        color: falseColor || "white",
        boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
        backgroundColor: "currentColor",
        borderRadius: "50%",
        textAlign: "center",
        marginTop: -2,
        height: "20px!important",
        width: "20px!important",
        "&>svg": {
            marginTop: 4,
            width: 10,
            color: trueColor || theme.palette.primary.main,
        },
    },
    "& .Mui-checked .MuiSwitch-thumb": {
        color: trueColor || theme.palette.primary.main,
        "&>svg": {
            color: falseColor || "white",
        },
    },
    "& .Mui-disabled": {
        color: `${theme.palette.text.primary}!important`,
        WebkitTextFillColor: "initial",
    },
    "&>.MuiGrid-container": {
        marginTop: 10,
        marginBottom: -4,
        "& .MuiGrid-item": {
            paddingTop: 4,
        },
        ...!label && { marginTop: -4 },
    },
    "& .MuiInputLabel-shrink": {
        fontSize: 12,
        transform: "translate(2px, -7px) scale(1) !important",
    },
    ...!label && { height: 24 },
}));

const CustomSwitch = React.memo((props) => {
    const {
        fullWidth,
        className,
        disabled,
        label,
        defaultValue,
        name,
        checked,
        onChange,
        onBlur,
        falseLabel,
        trueLabel,
        falseColor,
        trueColor,
        align,
        sx,
        inputRef,
        icon,
        checkedIcon,
        // error,
    } = props;

    return (
        <StyledFormControl
            className="PTMInput-switch"
            variant="outlined"
            disabled={disabled}
            fullWidth={fullWidth}
            sx={sx}
            falseColor={falseColor}
            trueColor={trueColor}
            label={label}
            // error={error}
        >
            {label ? (
                <InputLabel style={{ width: "100%", textAlign: align }}>
                    {label}
                </InputLabel>
            ) : null}
            <Grid component="label" wrap="nowrap" container alignItems="center" spacing={1} style={{ justifyContent: align }}>
                <Grid item>{falseLabel}</Grid>
                <Grid item>
                    <Switch
                        className={className}
                        name={name}
                        size="small"
                        color="primary"
                        checked={checked}
                        defaultChecked={defaultValue}
                        onChange={onChange}
                        onBlur={onBlur}
                        disabled={disabled}
                        inputRef={inputRef}
                        icon={<span className="MuiSwitch-thumb">{icon}</span>}
                        checkedIcon={<span className="MuiSwitch-thumb">{checkedIcon}</span>}
                        // checkedIcon={checkedIcon && (<IconButton color="primary">{checkedIcon}</IconButton>)}
                    />
                </Grid>
                <Grid item>{trueLabel}</Grid>
            </Grid>
        </StyledFormControl>
    );
});

export default CustomSwitch;
